import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import {
  getAggregateSentimentLabel,
  getSentimentPercentages,
  getTopicColor,
} from '@/metrics/pages/ReasonMetricDetailPage/helpers'
import SentimentLabel from '@/metrics/pages/ReasonMetricDetailPage/SentimentLabel/SentimentLabel'

import * as Styles from './styles'

const TopicDrawerHeader = ({ topic, sentiments }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const isOther = Boolean(topic.is_other)
  const color = getTopicColor({ rank: topic.rank, isOther }, theme)
  const sentimentLabel = getAggregateSentimentLabel(topic.aggregated_sentiment, theme)
  const { positive, neutral, negative } = getSentimentPercentages(sentiments, topic.note_count)

  const nameLabel = isOther ? t('Otros') : topic.name
  const noteCountText = topic.note_count === 1 ? '{{count}} nota' : '{{count}} notas'

  if (!topic) return null

  return (
    <Styles.Container>
      <Styles.TitleBlock>
        <Styles.TitleRow>
          <Styles.Dot color={color} />
          <Text type="titleS">{nameLabel}</Text>
        </Styles.TitleRow>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {t(noteCountText, { count: topic.note_count })}
        </Text>
      </Styles.TitleBlock>
      <Styles.SentimentRow>
        <Styles.Bar>
          <Styles.BarSegment width={negative} color={theme.colors.danger.default} />
          <Styles.BarSegment width={neutral} color={theme.colors.text.subtle} />
          <Styles.BarSegment width={positive} color={theme.colors.success.default} />
        </Styles.Bar>
        {sentimentLabel && <SentimentLabel type={topic.aggregated_sentiment} label={t(sentimentLabel)} />}
      </Styles.SentimentRow>
    </Styles.Container>
  )
}

export default TopicDrawerHeader
